<template lang="pug">
.container.grid-lg.py-2
  load-manager(:status="status")
    .pb-2.mb-2(v-if="current")
      section.top-header
        .columns
          item-col.col-auto(
            label="pontuacao_geral.referencia",
            :value="current.referencia",
            value-class="text-bold"
          )
          item-col.col-auto(
            label="pontuacao_geral.media_total",
            :value="current.media_total | currency",
            value-class="text-bold"
          )
          .column
          .column.col-auto
            a.btn.btn-link(:href="current.url", target="_blank")
              btn-content(name="print")
        .divider
      section
        .columns
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_geral.media_individual_bruto",
            :value="current.media_individual_bruto | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_geral.media_perdidos",
            :value="current.media_perdidos | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_geral.media_individual_liquido",
            :value="current.media_individual_liquido | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_geral.media_extraordinario",
            :value="current.media_extraordinario | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_geral.media_coletivo",
            :value="current.media_coletivo | currency"
          )
          item-col.my-1.col-4.col-sm-12(
            label="pontuacao_geral.encerrado",
            :value="current.encerrado ? 'Sim' : 'Não'"
          )
      section(v-if="current.resumos && current.resumos.length")
        .divider.text-center(data-content="Resumo Geral")
        show-resumos(:resumos="current.resumos")
      section(v-if="current.resumosExternos && current.resumosExternos.length")
        .divider.text-center(data-content="RESUMO EQUIPE EXTERNA")
        show-resumos(:resumos="current.resumosExternos")
      section(
        v-if="current.resumosTransicao && current.resumosTransicao.length"
      )
        .divider.text-center(data-content="RESUMO EQUIPE TRANSIÇÃO")
        show-resumos(:resumos="current.resumosTransicao")
      section(v-if="current.resumosInternos && current.resumosInternos.length")
        .divider.text-center(data-content="RESUMO EQUIPE INTERNA")
        show-resumos(:resumos="current.resumosInternos", :internos="true")
</template>

<script>
import ShowResumos from "./componentes/ShowResumos"

export default {
  vuex: {
    "produtividade/geral": {
      state: ["current", "status"],
      actions: ["fetchOne"],
    },
  },

  components: { ShowResumos },

  computed: {
    geralId() {
      return Number(this.$route.params.geralId)
    },
  },

  methods: {
    isFetchOne() {
      return !this.current || Number(this.current.id) !== this.geralId
    },
  },

  mounted() {
    if (this.isFetchOne()) {
      this.fetchOne(this.geralId)
    }
  },
}
</script>

<style lang="stylus" scoped>
.top-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  padding-top: 5px;
}
</style>
